import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CloneLogonResult } from '../../../../interfaces/clone-logon.interface';
import { CloneableLogonSearch } from '../../../../interfaces/cloneable-logon-search.interface';
import { PmeLogonsCount } from '../../../../../recertification/interfaces/user-me.interface';
import { UserAddMessagesHelper } from '../../helpers/user-add-messages.helper';
import { EmailIdEntryForm } from '../../components/email-id-list/email-id-list.component';

@Component({
  selector: 'pl-step-form',
  templateUrl: './step-form.component.html',
  styleUrls: ['./step-form.component.scss'],
  standalone: false,
})
export class StepFormComponent {
  @Input() entriesForm!: FormArray<FormGroup<EmailIdEntryForm>>;
  @Input() cloneableLogon: CloneableLogonSearch | undefined;
  @Input() errorMessage: { title?: string; description?: string } | undefined;
  @Input() hasError = false;
  @Input() isLoading = false;
  @Input() failedEmails: string[] = [];
  @Input() pmeLogonsCount: PmeLogonsCount | undefined;
  @Input() pmeLimitsUnavailable = false;
  @Input() pmeLimitReached = false;
  @Input() failedCloneResults: CloneLogonResult[] = [];

  public getFailedMessage(result: CloneLogonResult): string {
    if (!result.error) {
      return 'Não foi possível criar o usuário.';
    }
    return new UserAddMessagesHelper(result.error).error.description;
  }

  public getEmailLimit(): number {
    const limit = Number(this.pmeLogonsCount?.remainingCount);
    return Number.isFinite(limit) && limit >= 0 ? limit : 8;
  }

  public getEmailLimitTotal(): number {
    const total = Number(this.pmeLogonsCount?.maxAllowedCount);
    return Number.isFinite(total) && total >= 0 ? total : this.getEmailLimit();
  }

  public isPmeLimitAlmostReached(): boolean {
    const remaining = Number(this.pmeLogonsCount?.remainingCount);
    return Number.isFinite(remaining) && remaining > 0 && remaining <= 3;
  }
}
